// TODO: This is here as a temporary fix for multi-value query parameters
// See: https://github.com/aws-amplify/amplify-js/issues/13357
const urlFromMultiValueQueryParams = (url, queryParams) => {
  if (!queryParams) return url;


  const queryParamsEntries = Object.entries(queryParams);
  queryParamsEntries.reverse();

  const [k, v] = queryParamsEntries.pop();
  let path = `${url}?${k}=${v}`;

  for (const [key, value] of queryParamsEntries) {
    if (!Array.isArray(value)) {
      path += `&${key}=${value}`;
    } else {
      for (const item of value) {
        path += `&${key}=${item}`;
      }
    }
  }

  return path;
};


// eslint-disable-next-line import/prefer-default-export
export { urlFromMultiValueQueryParams };
